import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { IProviderProductObject } from '../../types/index'
import ButtonFilled from '../ui/ButtonFilledOrange'
import Modal from '../ui/Modal'
import UIMessages from 'src/utils/ui-messages'

interface IProviderProductDeleteModalProps {
  product: IProviderProductObject
  deleting: boolean
  error: string
  onCancelClick: () => void
  onDeleteClick: (product: IProviderProductObject) => void
}

class ProviderProductDeleteModal extends React.Component<IProviderProductDeleteModalProps> {
  constructor(props: IProviderProductDeleteModalProps) {
    super(props)
  }

  public render() {
    const { product, deleting, error, onCancelClick } = this.props

    const containerStyle = {
      width: 415,
      height: 200
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>Remove Product</span>
            <div className='mt1 border-top pt2'>
              <div className='font-grey3 h5'>Do you want to remove this product?</div>
              <li className='h5 font-grey3 mx-auto mt1 bold'>{product && product.name}</li>
            </div>
            {error && <div className='Error h5 font-orange mx-auto'>{error}</div>}
            <div className='mx-auto'>
              <MoonLoader sizeUnit={'px'} size={25} color={'#405264'} loading={deleting} />
            </div>
            <div className='flex items-center justify-end mt3'>
              <button type='button' onClick={onCancelClick} className='CancelButton custom-btn mbsc-clear-btn'>
                {UIMessages.common.cancel}
              </button>
              <button
                type='button'
                onClick={this.handleDeleteClick}
                className={'SubmitButton custom-btn mbsc-red-btn ml1'}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleDeleteClick = () => {
    this.props.onDeleteClick(this.props.product)
  }
}

export default ProviderProductDeleteModal



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductDeleteModal.tsx